import capitalize from 'lodash/capitalize';
import DataDefinitionsClient from './data-definitions-client';

const EXTRA_EVENT_DEFINITIONS = [
  {
    name: `$date`,
    displayName: `Date`,
    description: `The date and time this event occurred at. All events have this property.`,
    type: `datetime`,
    resourceType: `event`,
  },
];

class PropertyDefinitionsClient extends DataDefinitionsClient {
  buildEndpoint({projectId, workspaceId}) {
    return `${super.buildEndpoint({projectId, workspaceId})}/properties`;
  }

  /**
   * @param {number} id
   * @param {string} name
   * @param {'user'|'super'} category
   * @param {string} event
   * @param {boolean} includeCustom
   *
   * If category is defined, event is not, and vice-versa.
   *
   * Category has two possible values:
   *   user: grab user properties
   *   event: grab event properties
   *   super: grab properties present on the majority of events
   */
  buildQueryParams(options = {}) {
    const {id, name, category, event, includeCustom} = {
      includeCustom: false,
      ...options,
    };
    // "events" is a common mistake
    // the API is case sensitive, but our frontend javascript feeds in lowercase values
    const resourceType = category === `events` ? `Event` : capitalize(category) || undefined;
    return {id, name, resourceType, event, includeCustom};
  }

  processResponse(response, params) {
    const result = super.processResponse(response, params);
    // the API is case sensitive, but our frontend javascript expects lowercase values
    // TODO: fix the inconsistency with `events` and `event` on the param.category
    // use `user` for now
    const resourceType = params.category === `user` ? `user` : `event`;
    const extraDefs = params.category === `user` ? [] : EXTRA_EVENT_DEFINITIONS;
    if (Array.isArray(result)) {
      return [...result.map((def) => ({...def, resourceType})), ...extraDefs];
    } else {
      return {...result, resourceType};
    }
  }
}

export default new PropertyDefinitionsClient();
